<template>
  <div>
    <div class="alert alert-info" v-if="$user.isNotActivated">
			<i class="alert-icon far fa-exclamation-triangle"></i>
			Your carrier account is pending verification from Arrow Logistics.
		</div>

    <div v-if="$user.isClient">
      <div class="alert alert-danger" v-if="$user.isDisabled && haveUnpaidInvoices">
			  <i class="alert-icon far fa-exclamation-triangle"></i>
        This account is suspended, an invoice is 35 days overdue, please contact Arrow Logistics.
      </div>
      <div class="alert alert-warning" v-if="haveUnpaidInvoices">
			  <i class="alert-icon far fa-exclamation-triangle"></i>
        This account has {{ $user.unpaid_invoices_count }} unpaid invoices.
      </div>
    </div>

    <widgets></widgets>
    <load-request-list v-if="$user.isCarrier"></load-request-list>
    <load-list v-if="$user.isCarrier"></load-list>
    <job-request-list v-if="$user.isAdmin"></job-request-list>
    <job-list></job-list>
    <invoice-list v-if="$user.isClientOrCarrier"></invoice-list>
  </div>
</template>

<script>
  import LoadRequestList from './dashboard/LoadRequestList'
  import LoadList from './dashboard/LoadList'
  import JobRequestList from './dashboard/JobRequestList'
  import JobList from './dashboard/JobList'
  import InvoiceList from './dashboard/InvoiceList'
  import Widgets from './dashboard/Widgets'

  export default {
    components: {
      LoadRequestList,
      LoadList,
      JobRequestList,
      JobList,
      InvoiceList,
      Widgets
    },

    computed: {
      haveUnpaidInvoices () {
        return this.$user.unpaid_invoices_count > 0
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Dashboard.vue?e205b49a